import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "emp-myinfo-page" }
const _hoisted_2 = { class: "app-header" }
const _hoisted_3 = { class: "page-content" }
const _hoisted_4 = { class: "profile-card" }
const _hoisted_5 = { class: "profile-avatar" }
const _hoisted_6 = { class: "profile-info" }
const _hoisted_7 = { class: "name" }
const _hoisted_8 = { class: "job" }
const _hoisted_9 = {
  key: 0,
  class: "badge"
}
const _hoisted_10 = { class: "info-card" }
const _hoisted_11 = { class: "info-section" }
const _hoisted_12 = { class: "info-row" }
const _hoisted_13 = { class: "value" }
const _hoisted_14 = { class: "info-row" }
const _hoisted_15 = { class: "value" }
const _hoisted_16 = { class: "info-row" }
const _hoisted_17 = { class: "value" }
const _hoisted_18 = {
  key: 0,
  class: "info-row"
}
const _hoisted_19 = { class: "value warning" }
const _hoisted_20 = {
  key: 1,
  class: "info-row"
}
const _hoisted_21 = { class: "value highlight" }
const _hoisted_22 = { class: "info-section" }
const _hoisted_23 = { class: "info-row" }
const _hoisted_24 = { class: "value" }
const _hoisted_25 = { class: "info-row" }
const _hoisted_26 = { class: "value" }
const _hoisted_27 = { class: "info-row" }
const _hoisted_28 = { class: "value code" }
const _hoisted_29 = { class: "info-section" }
const _hoisted_30 = { class: "info-row" }
const _hoisted_31 = { class: "value" }
const _hoisted_32 = ["href"]
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { class: "info-row" }
const _hoisted_35 = { class: "value" }
const _hoisted_36 = ["href"]
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { class: "info-section" }
const _hoisted_39 = { class: "info-row" }
const _hoisted_40 = { class: "value" }
const _hoisted_41 = { class: "code" }
const _hoisted_42 = { class: "info-row" }
const _hoisted_43 = { class: "value" }
const _hoisted_44 = { class: "dialog-header" }
const _hoisted_45 = { class: "dialog-content" }
const _hoisted_46 = { class: "input-group" }
const _hoisted_47 = ["value"]
const _hoisted_48 = { class: "input-group" }
const _hoisted_49 = { class: "input-with-check" }
const _hoisted_50 = {
  key: 0,
  class: "check-status"
}
const _hoisted_51 = {
  key: 0,
  class: "hint"
}
const _hoisted_52 = {
  key: 1,
  class: "hint",
  style: {"color":"#059669"}
}
const _hoisted_53 = {
  key: 2,
  class: "hint error"
}
const _hoisted_54 = {
  key: 3,
  class: "hint error"
}
const _hoisted_55 = { class: "input-group" }
const _hoisted_56 = { class: "dialog-actions" }
const _hoisted_57 = ["disabled"]
const _hoisted_58 = { key: 1 }
const _hoisted_59 = { class: "dialog-header" }
const _hoisted_60 = { class: "dialog-content" }
const _hoisted_61 = { class: "input-group" }
const _hoisted_62 = { class: "input-group" }
const _hoisted_63 = {
  key: 0,
  class: "hint"
}
const _hoisted_64 = { class: "input-group" }
const _hoisted_65 = {
  key: 0,
  class: "hint error"
}
const _hoisted_66 = { class: "dialog-actions" }
const _hoisted_67 = ["disabled"]
const _hoisted_68 = { key: 1 }
const _hoisted_69 = { class: "notice-card" }

import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import axios from 'axios';


export default /*@__PURE__*/_defineComponent({
  __name: 'EmpMyInfo',
  setup(__props) {

const store = useStore();
const router = useRouter();
const pwaUser = computed(() => store.getters['pwa/pwaUser']);

// 뒤로가기
const goBack = () => {
  router.back();
};

// 아이디 변경
const showIdDialog = ref(false);
const newId = ref('');
const idCurrentPw = ref('');
const isChangingId = ref(false);
const isCheckingId = ref(false);
const idCheckResult = ref<'available' | 'duplicate' | 'invalid' | null>(null);
let idCheckTimeout: ReturnType<typeof setTimeout> | null = null;

const canChangeId = computed(() => {
  return newId.value.length >= 4 && 
         newId.value.length <= 20 && 
         /^[a-zA-Z0-9_]+$/.test(newId.value) &&
         idCurrentPw.value.length > 0 &&
         idCheckResult.value === 'available';
});

// 아이디 입력 시 중복 검사
const onIdInput = () => {
  // 이전 타이머 취소
  if (idCheckTimeout) {
    clearTimeout(idCheckTimeout);
  }
  
  const id = newId.value.trim();
  
  // 길이 체크
  if (id.length < 4) {
    idCheckResult.value = null;
    return;
  }
  
  // 형식 체크
  if (!/^[a-zA-Z0-9_]+$/.test(id)) {
    idCheckResult.value = 'invalid';
    return;
  }
  
  // 현재 아이디와 동일한지 체크
  if (id === pwaUser.value?.emp_id) {
    idCheckResult.value = 'duplicate';
    return;
  }
  
  // 디바운스: 300ms 후에 API 호출
  idCheckTimeout = setTimeout(async () => {
    isCheckingId.value = true;
    try {
      const response = await axios.get(`/api/emp/check-id/${id}`, { withCredentials: true });
      if (response.data.exists) {
        idCheckResult.value = 'duplicate';
      } else {
        idCheckResult.value = 'available';
      }
    } catch (error) {
      console.error('아이디 중복 체크 오류:', error);
      idCheckResult.value = null;
    } finally {
      isCheckingId.value = false;
    }
  }, 300);
};

const openIdDialog = () => {
  newId.value = '';
  idCurrentPw.value = '';
  idCheckResult.value = null;
  showIdDialog.value = true;
};

const closeIdDialog = () => {
  showIdDialog.value = false;
  newId.value = '';
  idCurrentPw.value = '';
  idCheckResult.value = null;
};

const changeId = async () => {
  if (!canChangeId.value || isChangingId.value) return;
  
  isChangingId.value = true;
  try {
    const response = await axios.put(
      `/api/emp/facility/${pwaUser.value.emp_idx}/id`,
      { newId: newId.value, currentPw: idCurrentPw.value },
      { withCredentials: true }
    );
    
    if (response.data.success) {
      store.commit('showSnackbar', { text: '아이디가 변경되었습니다.', color: 'success' });
      // pwaUser 업데이트
      store.commit('pwa/updatePwaUser', { emp_id: newId.value });
      closeIdDialog();
    } else {
      store.commit('showSnackbar', { text: response.data.message || '아이디 변경에 실패했습니다.', color: 'error' });
    }
  } catch (error: any) {
    console.error('아이디 변경 오류:', error);
    const message = error.response?.data?.message || '아이디 변경 중 오류가 발생했습니다.';
    store.commit('showSnackbar', { text: message, color: 'error' });
  } finally {
    isChangingId.value = false;
  }
};

// 비밀번호 변경
const showPwDialog = ref(false);
const currentPw = ref('');
const newPw = ref('');
const confirmPw = ref('');
const isChangingPw = ref(false);

const canChangePw = computed(() => {
  return currentPw.value.length > 0 && 
         newPw.value.length >= 4 && 
         newPw.value === confirmPw.value;
});

const openPwDialog = () => {
  currentPw.value = '';
  newPw.value = '';
  confirmPw.value = '';
  showPwDialog.value = true;
};

const closePwDialog = () => {
  showPwDialog.value = false;
  currentPw.value = '';
  newPw.value = '';
  confirmPw.value = '';
};

const changePw = async () => {
  if (!canChangePw.value || isChangingPw.value) return;
  
  isChangingPw.value = true;
  try {
    const response = await axios.put(
      `/api/emp/facility/${pwaUser.value.emp_idx}/password`,
      { currentPw: currentPw.value, newPw: newPw.value },
      { withCredentials: true }
    );
    
    if (response.data.success) {
      store.commit('showSnackbar', { text: '비밀번호가 변경되었습니다.', color: 'success' });
      closePwDialog();
    } else {
      store.commit('showSnackbar', { text: response.data.message || '비밀번호 변경에 실패했습니다.', color: 'error' });
    }
  } catch (error: any) {
    console.error('비밀번호 변경 오류:', error);
    const message = error.response?.data?.message || '비밀번호 변경 중 오류가 발생했습니다.';
    store.commit('showSnackbar', { text: message, color: 'error' });
  } finally {
    isChangingPw.value = false;
  }
};

// 근무 기간 계산
const workDays = computed(() => {
  if (!pwaUser.value?.emp_in_date) return null;
  
  const startDate = new Date(pwaUser.value.emp_in_date);
  const endDate = pwaUser.value.emp_out_date 
    ? new Date(pwaUser.value.emp_out_date) 
    : new Date();
  
  const diffTime = Math.abs(endDate.getTime() - startDate.getTime());
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  
  const years = Math.floor(diffDays / 365);
  const months = Math.floor((diffDays % 365) / 30);
  const days = diffDays % 30;
  
  let result = '';
  if (years > 0) result += `${years}년 `;
  if (months > 0) result += `${months}개월 `;
  if (days > 0 || result === '') result += `${days}일`;
  
  return result.trim();
});

// 날짜 포맷
const formatDate = (date: string | null | undefined): string => {
  if (!date) return '-';
  try {
    const d = new Date(date);
    return d.toLocaleDateString('ko-KR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  } catch {
    return date;
  }
};

// 생년월일 포맷
const formatBirthDate = (birth: string | null | undefined): string => {
  if (!birth) return '-';
  // YYMMDD 또는 YYYYMMDD 형식 처리
  if (birth.length === 6) {
    const year = parseInt(birth.substring(0, 2));
    const fullYear = year > 30 ? 1900 + year : 2000 + year;
    return `${fullYear}년 ${birth.substring(2, 4)}월 ${birth.substring(4, 6)}일`;
  } else if (birth.length === 8) {
    return `${birth.substring(0, 4)}년 ${birth.substring(4, 6)}월 ${birth.substring(6, 8)}일`;
  } else if (birth.includes('-')) {
    return formatDate(birth);
  }
  return birth;
};

// 전화번호 포맷
const formatPhone = (phone: string | null | undefined): string => {
  if (!phone) return '-';
  const cleaned = phone.replace(/\D/g, '');
  if (cleaned.length === 11) {
    return `${cleaned.substring(0, 3)}-${cleaned.substring(3, 7)}-${cleaned.substring(7)}`;
  } else if (cleaned.length === 10) {
    return `${cleaned.substring(0, 3)}-${cleaned.substring(3, 6)}-${cleaned.substring(6)}`;
  }
  return phone;
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "back-btn",
        onClick: goBack
      }, [
        _createVNode(_component_v_icon, {
          size: "24",
          color: "white"
        }, {
          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
            _createTextVNode("mdi-arrow-left", -1)
          ]))]),
          _: 1
        })
      ]),
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "header-title" }, "내 정보", -1)),
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "header-spacer" }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_v_icon, {
            size: "40",
            color: "white"
          }, {
            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
              _createTextVNode("mdi-account", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h2", _hoisted_7, _toDisplayString(pwaUser.value?.emp_name || '-'), 1),
          _createElementVNode("p", _hoisted_8, _toDisplayString(pwaUser.value?.emp_job || '-'), 1),
          (pwaUser.value?.emp_isboss === 'Y')
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_v_icon, {
                  size: "14",
                  color: "white"
                }, {
                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                    _createTextVNode("mdi-crown", -1)
                  ]))]),
                  _: 1
                }),
                _cache[12] || (_cache[12] = _createElementVNode("span", null, "대표자", -1))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("h3", null, [
            _createVNode(_component_v_icon, {
              size: "18",
              color: "#059669"
            }, {
              default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                _createTextVNode("mdi-briefcase-outline", -1)
              ]))]),
              _: 1
            }),
            _cache[14] || (_cache[14] = _createTextVNode(" 근무 정보 ", -1))
          ]),
          _createElementVNode("div", _hoisted_12, [
            _cache[15] || (_cache[15] = _createElementVNode("span", { class: "label" }, "소속", -1)),
            _createElementVNode("span", _hoisted_13, _toDisplayString(pwaUser.value?.sisul_name || pwaUser.value?.m_sisul_name || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _cache[16] || (_cache[16] = _createElementVNode("span", { class: "label" }, "직종", -1)),
            _createElementVNode("span", _hoisted_15, _toDisplayString(pwaUser.value?.emp_job || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _cache[17] || (_cache[17] = _createElementVNode("span", { class: "label" }, "입사일", -1)),
            _createElementVNode("span", _hoisted_17, _toDisplayString(formatDate(pwaUser.value?.emp_in_date)), 1)
          ]),
          (pwaUser.value?.emp_out_date)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _cache[18] || (_cache[18] = _createElementVNode("span", { class: "label" }, "퇴사일", -1)),
                _createElementVNode("span", _hoisted_19, _toDisplayString(formatDate(pwaUser.value?.emp_out_date)), 1)
              ]))
            : _createCommentVNode("", true),
          (workDays.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _cache[19] || (_cache[19] = _createElementVNode("span", { class: "label" }, "근무기간", -1)),
                _createElementVNode("span", _hoisted_21, _toDisplayString(workDays.value), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("h3", null, [
            _createVNode(_component_v_icon, {
              size: "18",
              color: "#059669"
            }, {
              default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                _createTextVNode("mdi-card-account-details-outline", -1)
              ]))]),
              _: 1
            }),
            _cache[21] || (_cache[21] = _createTextVNode(" 기본 정보 ", -1))
          ]),
          _createElementVNode("div", _hoisted_23, [
            _cache[22] || (_cache[22] = _createElementVNode("span", { class: "label" }, "이름", -1)),
            _createElementVNode("span", _hoisted_24, _toDisplayString(pwaUser.value?.emp_name || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_25, [
            _cache[23] || (_cache[23] = _createElementVNode("span", { class: "label" }, "생년월일", -1)),
            _createElementVNode("span", _hoisted_26, _toDisplayString(formatBirthDate(pwaUser.value?.emp_birth)), 1)
          ]),
          _createElementVNode("div", _hoisted_27, [
            _cache[24] || (_cache[24] = _createElementVNode("span", { class: "label" }, "사원코드", -1)),
            _createElementVNode("span", _hoisted_28, _toDisplayString(pwaUser.value?.emp_code || '-'), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("h3", null, [
            _createVNode(_component_v_icon, {
              size: "18",
              color: "#059669"
            }, {
              default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                _createTextVNode("mdi-phone-outline", -1)
              ]))]),
              _: 1
            }),
            _cache[26] || (_cache[26] = _createTextVNode(" 연락처 정보 ", -1))
          ]),
          _createElementVNode("div", _hoisted_30, [
            _cache[27] || (_cache[27] = _createElementVNode("span", { class: "label" }, "휴대폰", -1)),
            _createElementVNode("span", _hoisted_31, [
              (pwaUser.value?.emp_phone)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: 'tel:' + pwaUser.value.emp_phone,
                    class: "phone-link"
                  }, _toDisplayString(formatPhone(pwaUser.value?.emp_phone)), 9, _hoisted_32))
                : (_openBlock(), _createElementBlock("span", _hoisted_33, "-"))
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _cache[28] || (_cache[28] = _createElementVNode("span", { class: "label" }, "이메일", -1)),
            _createElementVNode("span", _hoisted_35, [
              (pwaUser.value?.emp_email)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: 'mailto:' + pwaUser.value.emp_email,
                    class: "email-link"
                  }, _toDisplayString(pwaUser.value?.emp_email), 9, _hoisted_36))
                : (_openBlock(), _createElementBlock("span", _hoisted_37, "-"))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("h3", null, [
            _createVNode(_component_v_icon, {
              size: "18",
              color: "#059669"
            }, {
              default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                _createTextVNode("mdi-account-key-outline", -1)
              ]))]),
              _: 1
            }),
            _cache[30] || (_cache[30] = _createTextVNode(" 계정 정보 ", -1))
          ]),
          _createElementVNode("div", _hoisted_39, [
            _cache[33] || (_cache[33] = _createElementVNode("span", { class: "label" }, "아이디", -1)),
            _createElementVNode("span", _hoisted_40, [
              _createElementVNode("span", _hoisted_41, _toDisplayString(pwaUser.value?.emp_id || '-'), 1),
              _createElementVNode("button", {
                class: "change-link",
                onClick: openIdDialog
              }, [
                _cache[32] || (_cache[32] = _createTextVNode(" 변경 ", -1)),
                _createVNode(_component_v_icon, {
                  size: "12",
                  color: "#059669"
                }, {
                  default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                    _createTextVNode("mdi-pencil", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_42, [
            _cache[36] || (_cache[36] = _createElementVNode("span", { class: "label" }, "비밀번호", -1)),
            _createElementVNode("span", _hoisted_43, [
              _createElementVNode("button", {
                class: "change-link",
                onClick: openPwDialog
              }, [
                _cache[35] || (_cache[35] = _createTextVNode(" 변경하기 ", -1)),
                _createVNode(_component_v_icon, {
                  size: "14",
                  color: "#059669"
                }, {
                  default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                    _createTextVNode("mdi-chevron-right", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_v_dialog, {
        modelValue: showIdDialog.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showIdDialog).value = $event)),
        "max-width": "340"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { class: "change-dialog" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_44, [
                _cache[38] || (_cache[38] = _createElementVNode("h3", null, "아이디 변경", -1)),
                _createElementVNode("button", {
                  class: "close-btn",
                  onClick: closeIdDialog
                }, [
                  _createVNode(_component_v_icon, { size: "20" }, {
                    default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                      _createTextVNode("mdi-close", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _cache[39] || (_cache[39] = _createElementVNode("label", null, "현재 아이디", -1)),
                  _createElementVNode("input", {
                    type: "text",
                    value: pwaUser.value?.emp_id,
                    disabled: "",
                    class: "disabled-input"
                  }, null, 8, _hoisted_47)
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _cache[43] || (_cache[43] = _createElementVNode("label", null, "새 아이디", -1)),
                  _createElementVNode("div", _hoisted_49, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newId).value = $event)),
                      placeholder: "4~20자 (영문, 숫자, _)",
                      maxlength: "20",
                      onInput: onIdInput,
                      class: _normalizeClass({ 
                  'valid': idCheckResult.value === 'available',
                  'invalid': idCheckResult.value === 'duplicate' || idCheckResult.value === 'invalid'
                })
                    }, null, 34), [
                      [_vModelText, newId.value]
                    ]),
                    (newId.value.length >= 4)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                          (isCheckingId.value)
                            ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                key: 0,
                                indeterminate: "",
                                size: "16",
                                width: "2",
                                color: "#059669"
                              }))
                            : (idCheckResult.value === 'available')
                              ? (_openBlock(), _createBlock(_component_v_icon, {
                                  key: 1,
                                  size: "18",
                                  color: "#059669"
                                }, {
                                  default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                                    _createTextVNode("mdi-check-circle", -1)
                                  ]))]),
                                  _: 1
                                }))
                              : (idCheckResult.value === 'duplicate')
                                ? (_openBlock(), _createBlock(_component_v_icon, {
                                    key: 2,
                                    size: "18",
                                    color: "#dc2626"
                                  }, {
                                    default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                                      _createTextVNode("mdi-close-circle", -1)
                                    ]))]),
                                    _: 1
                                  }))
                                : (idCheckResult.value === 'invalid')
                                  ? (_openBlock(), _createBlock(_component_v_icon, {
                                      key: 3,
                                      size: "18",
                                      color: "#dc2626"
                                    }, {
                                      default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                                        _createTextVNode("mdi-alert-circle", -1)
                                      ]))]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (newId.value && newId.value.length < 4)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_51, "4자 이상 입력해주세요."))
                    : (idCheckResult.value === 'available')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_52, "사용 가능한 아이디입니다."))
                      : (idCheckResult.value === 'duplicate')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_53, "이미 사용 중인 아이디입니다."))
                        : (idCheckResult.value === 'invalid')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_54, "영문, 숫자, 언더스코어(_)만 사용 가능합니다."))
                          : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_55, [
                  _cache[44] || (_cache[44] = _createElementVNode("label", null, "비밀번호 확인", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((idCurrentPw).value = $event)),
                    placeholder: "현재 비밀번호 입력"
                  }, null, 512), [
                    [_vModelText, idCurrentPw.value]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("button", {
                  class: "cancel-btn",
                  onClick: closeIdDialog
                }, "취소"),
                _createElementVNode("button", {
                  class: "confirm-btn",
                  disabled: !canChangeId.value || isChangingId.value,
                  onClick: changeId
                }, [
                  (isChangingId.value)
                    ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                        key: 0,
                        indeterminate: "",
                        size: "16",
                        width: "2",
                        color: "white"
                      }))
                    : (_openBlock(), _createElementBlock("span", _hoisted_58, "변경"))
                ], 8, _hoisted_57)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_dialog, {
        modelValue: showPwDialog.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((showPwDialog).value = $event)),
        "max-width": "340"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { class: "change-dialog" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_59, [
                _cache[46] || (_cache[46] = _createElementVNode("h3", null, "비밀번호 변경", -1)),
                _createElementVNode("button", {
                  class: "close-btn",
                  onClick: closePwDialog
                }, [
                  _createVNode(_component_v_icon, { size: "20" }, {
                    default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                      _createTextVNode("mdi-close", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("div", _hoisted_61, [
                  _cache[47] || (_cache[47] = _createElementVNode("label", null, "현재 비밀번호", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((currentPw).value = $event)),
                    placeholder: "현재 비밀번호 입력"
                  }, null, 512), [
                    [_vModelText, currentPw.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_62, [
                  _cache[48] || (_cache[48] = _createElementVNode("label", null, "새 비밀번호", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((newPw).value = $event)),
                    placeholder: "4자 이상"
                  }, null, 512), [
                    [_vModelText, newPw.value]
                  ]),
                  (newPw.value && newPw.value.length < 4)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_63, "4자 이상 입력해주세요."))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_64, [
                  _cache[49] || (_cache[49] = _createElementVNode("label", null, "새 비밀번호 확인", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((confirmPw).value = $event)),
                    placeholder: "새 비밀번호 다시 입력"
                  }, null, 512), [
                    [_vModelText, confirmPw.value]
                  ]),
                  (confirmPw.value && newPw.value !== confirmPw.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_65, "비밀번호가 일치하지 않습니다."))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("button", {
                  class: "cancel-btn",
                  onClick: closePwDialog
                }, "취소"),
                _createElementVNode("button", {
                  class: "confirm-btn",
                  disabled: !canChangePw.value || isChangingPw.value,
                  onClick: changePw
                }, [
                  (isChangingPw.value)
                    ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                        key: 0,
                        indeterminate: "",
                        size: "16",
                        width: "2",
                        color: "white"
                      }))
                    : (_openBlock(), _createElementBlock("span", _hoisted_68, "변경"))
                ], 8, _hoisted_67)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_69, [
        _createVNode(_component_v_icon, {
          size: "18",
          color: "#d97706"
        }, {
          default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
            _createTextVNode("mdi-alert-circle-outline", -1)
          ]))]),
          _: 1
        }),
        _cache[51] || (_cache[51] = _createElementVNode("p", null, "개인정보 수정이 필요하신 경우 센터 관리자에게 문의해주세요.", -1))
      ])
    ])
  ]))
}
}

})